import { useEffect, useRef } from 'react'
import { gaMeasurementId } from '@/config'
import { localCache } from '@hotcoin/utils/dist/utils/cache'
/**
 * Google Analytics 用户追踪 Hook
 *
 * @description
 * 用于配置 Google Analytics (GA4) 的用户标识。
 * 当用户登录后，将用户的 fid 设置为 GA 的 user_id，
 * 用于跨设备追踪用户行为。
 *
 * @remarks
 * - 只在客户端执行
 * - 依赖用户登录状态
 * - 使用 GA4 配置
 */
const useGA4UserAndDeviceTracking = () => {
  const hasExecuted = useRef(false)
  useEffect(() => {
    if (!hasExecuted.current && typeof window !== 'undefined') {
      const user_id = localCache.getCache('userInfo')?.fid
      const fingerprint = localCache.getCache('fingerprint_device_id_v1')
      if (user_id) {
        window.gtag('config', gaMeasurementId, {
          send_page_view: true,
          user_id,
          fingerprint,
        })
      }
      hasExecuted.current = true
    }
  }, [])
}

export default useGA4UserAndDeviceTracking
